// in ActionProvider.jsx
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Loader from './loader';
import { getResponse, submitBooking, updateHeaders } from './api';
import { ActionType, store } from './store.tsx';
// import 'react-calendar/dist/Calendar.css';
import './ActionProvider.css';
import ContactForm from './contactForm.tsx';

const ActionProvider = ({ createChatBotMessage, createClientMessage, setState, children }) => {

  const globalStore = useContext(store);

  const [lawfirmId, setLawfirmId] = useState(undefined);
  const [selectedDate, setSelectedDate] = useState(undefined);

  // Could be passed into contact form, although it's not used in the current implementation.
  const [availableTimes, setAvailableTimes] = useState([]);

  const sendCustomizedUserMessage = (message) => {
    globalStore.dispatch({ type: ActionType.SUBMIT_CUSTOMIZED_MESSAGE, payload: message });
    console.log('sendCustomizedUserMessage message', message);
  }

  /**
   * The response to answer the user's question, and provide some relative questions.
   * @param {string} mainText
   * @param {string[]} relativeQuestions
   * @returns {Element}
   */
  function getNormalResponseHTML(mainText) {
    return (
      <>
        <div>{mainText}</div>
      </>
    );
  }

  function getRelativeQuestionResponseHTML(displayContent, relativeQuestions, onQuestionClick) {
    return (
      <>
        <div>{displayContent}</div>
        {relativeQuestions.length > 0 && (
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {relativeQuestions.map((question, index) => (
              <li key={index}
                  onClick={() => onQuestionClick(question)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#f2f2f2',
                    margin: '5px 0',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    transition: 'background-color 0.3s',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#e2e2e2';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#f2f2f2';
                  }}
              >
                {question}
              </li>
            ))}
          </ul>
        )}
      </>
    );
  }

  function getFormattedDate(date) {
    console.log('getFormattedDate >> date', date)
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}年${month}月${day}日`;
  }

  const handleContactFormSubmit = useCallback(
    (formData) => {
      console.log('handleContactFormSubmit >> formData', formData, 'selectedData', selectedDate);
      const bookingData = {
        'UserName': formData.name,
        'UserPhone': formData.phone,
        'UserEmail': formData.email,
        'UserAppointmentTime': selectedDate,
        'LawfirmId': lawfirmId,
      }

      const botMessage = createChatBotMessage('正在处理您的预约，请稍等...', { withAvatar: true });
      setState(prev => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));

      submitBooking(bookingData)
        .then((response) => {
          console.log('submitBooking >> response', response);
          if (response.RetCode === 0) {
            handleReceive();
          } else {
            const botMessage = createChatBotMessage('预约提交失败，请再试一次。');
            setState(prev => ({
              ...prev,
              messages: [...prev.messages, botMessage],
            }));
          }
        });
    },
    [lawfirmId, createChatBotMessage, setState, selectedDate] // Include selectedData here
  );

  useEffect(() => {
    console.log('ActionProvider >> selectedDate', selectedDate)

    if (selectedDate) {
      const botMessage = createChatBotMessage(
        <ContactForm submitCallback={handleContactFormSubmit}/>
      );
      setState(prev => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));
    }

  }, [selectedDate]);

  const handleDateChange = useCallback(
    (date) => {
      setSelectedDate(date);
      // If RetCode is -1, it means the request has timed out.
      // const formattedDate = getFormattedDate(date);
      const botMessage = createChatBotMessage('您选择了' + date + '。请你填写联系方式:');
      setState(prev => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));
    },
    [createChatBotMessage, setState]
  );

  /**
   *
   * @param {AppointmentCard} appointmentCard
   * @returns {Element}
   */
  function getAppointmentCardHTML(appointmentCard) {
    const displayContent = appointmentCard.DisplayContent;
    const availableTimes = appointmentCard.AvailableAppointmentTime;

    // Convert the available times from strings to Date objects
    const availableDates = availableTimes.map(time => {
      const dateRegex = /(\d{4})年(\d{2})月(\d{2})日/;
      const match = time.match(dateRegex);
      if (match) {
        const year = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1; // JavaScript months are 0-indexed
        const day = parseInt(match[3], 10);
        return new Date(year, month, day).toDateString();
      }
      return null;
    }).filter(date => date); // Filter out null values

    // Function to check if a date is available
    const isDateAvailable = (date) => {
      return availableDates.includes(date.toDateString());
    };

    setAvailableTimes(availableTimes);


    return (
      <>
        <div>{displayContent}</div>
        {/*<Calendar*/}
        {/*  tileDisabled={({ date, view }) => view === 'month' && !isDateAvailable(date)}*/}
        {/*  onClickDay={(value) => {*/}
        {/*    handleDateChange(value);*/}
        {/*    console.log('Clicked day:', value)*/}
        {/*  }}*/}
        {/*/>*/}
        <div className="available-times">
          {availableTimes.map((time, index) => (
            <p key={index} className="time-slot" onClick={() => handleDateChange(time)}>
              {time}
            </p>
          ))}
        </div>
      </>
    );
  }

  const handleHello = () => {
    const botMessage = createChatBotMessage('Hello. Nice to meet you.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  const handleReceive = async () => {
    const botMessage = createChatBotMessage(<Loader/>);
    setState(prev => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));

    const sendRequest = async () => {
      try {
        const timer = new Promise((resolve) => {
          setTimeout(() => {
            resolve({ RetCode: -1 });
          }, 30000); // 30 seconds
        });

        /**
         * Race the timer promise against the `getResponse` promise.
         * If the timer promise resolves first, it means the request has timed out.
         * @type {SendMessageResponse}
         * */
        const response = await Promise.race([getResponse(), timer]);
        console.log('[DEBUG] >> Chatbot response received:', response);

        if (response.RetCode !== 0) {
          if (response.RetCode === -1) {
            // If RetCode is -1, it means the request has timed out.
            const botMessage = createChatBotMessage('工作人员繁忙，请再试一次');
            setState(prev => ({
              ...prev,
              messages: [...prev.messages, botMessage],
            }));
          } else {
            // If RetCode is not 0, retry after 0.5s
            setTimeout(() => {
              sendRequest();
            }, 2000);
          }
        } else {
          console.log('[DEBUG] >> Chatbot response RetCode', response.RetCode)

          const delay = 1000;

          const agentMessages = response.AgentMessage;

          if (agentMessages.length === 0) {
            return;
          }


          let botMessageArray = [];

          agentMessages.forEach((msg, index) => {
            console.log('DEBUG >> Response message', index, msg);

            let botMessage;

            switch (msg.Response.ContentType) {
              case 'Normal':
                console.log('DEBUG >> type', msg.Response.ContentType);
                const answer = msg.Response.Content || '';
                if (answer !== '') {
                  botMessage = createChatBotMessage(
                    getNormalResponseHTML(answer),
                    { withAvatar: true }
                  );
                }
                break;
              case 'RelationQuestion':
                console.log('DEBUG >> type', msg.Response.ContentType);
                const relativeQuestions = msg.Response.RelationQuestion.Questions;
                const displayContent = msg.Response.RelationQuestion.DisplayContent;
                if (relativeQuestions && relativeQuestions.length > 0) {
                  botMessage = createChatBotMessage(
                    getRelativeQuestionResponseHTML(displayContent, relativeQuestions, sendCustomizedUserMessage)
                  );
                }
                break;
              case 'AppointmentCard':
                console.log('DEBUG >> Chatbot response message', msg.Response.ContentType);
                const appointmentCard = msg.Response.AppointmentCard;
                if (appointmentCard) {
                  setLawfirmId(appointmentCard.LawfirmId);
                  updateHeaders({
                    'LEGALLINK-LANGUAGE': appointmentCard.Language,
                    'LEGALLINK-TIMEZONE': appointmentCard.TimeZone,
                  })
                  botMessage = createChatBotMessage(
                    getAppointmentCardHTML(appointmentCard)
                  );
                }
                break;
              default:
                break;
            }

            if (botMessage) {
              botMessageArray.push(botMessage);
            }
          });

          console.log('DEBUG >> botMessageArray', botMessageArray)

          botMessageArray.forEach((msg, index) => {
            setTimeout(() => {
              console.log('DEBUG >> botMessage', msg)
              setState(prev => {
                // If the message is the first one, replace the last message with the new message.
                // Because the last message is the loading spinner.
                const prevMessagesWithoutLast = index === 0
                  ? prev.messages.slice(0, -1)
                  : prev.messages;
                return {
                  ...prev,
                  messages: [...prevMessagesWithoutLast, msg],
                };
              });
            }, delay * index);
          });
        }

        // TODO: response.AgentMessage[3], booking reminder.
      } catch (error) {
        // TODO: Handle error appropriately
        console.error('[DEBUG] >> Chatbot response error', error);
      }
    };

    // Initial request
    sendRequest();
  };

  /**
   * @param {string[]} messages
   */
  const displayWelcomeMessages = (messages) => {
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, ...messages.map((m) => createChatBotMessage(m, { withAvatar: true }))],
    }));
  };

  /**
   * @param {HistoryResponseData[]} historyEntries
   */
  const displayHistoryMessages = (historyEntries) => {
    // console.log('[displayHistoryMessages] historyEntries', historyEntries);
    historyEntries.forEach((entry) => {
      if (entry.ContentType === 'Normal') {
        if (entry.DisplayRole === 'lawfirm') {
          const botMessage = createChatBotMessage(entry.Content, { withAvatar: true });
          setState((prev) => ({
            ...prev,
            messages: [...prev.messages, botMessage],
          }));
        } else if (entry.DisplayRole === 'toc_user') {
          const userMessage = createClientMessage(entry.Content, { withAvatar: true });
          setState((prev) => ({
            ...prev,
            messages: [...prev.messages, userMessage],
          }));
        } else {
          console.warn('[displayHistoryMessages] Unknown DisplayRole:', entry.DisplayRole);
        }
      }
    });
  };

  // useEffect(() => {
  //
  //   displayWelcomeMessages(globalStore.state.welcomeMessage);
  //   globalStore.dispatch({ type: ActionType.HAS_DISPLAYED_WELCOME, payload: true });
  //
  // }, [globalStore.state.welcomeMessage]);

  useEffect(() => {
    if (globalStore.state.initialized) {
      if (globalStore.state.chatHistory.length > 0) {
        displayHistoryMessages(globalStore.state.chatHistory);
      } else {
        if (globalStore.state.welcomeMessage.length > 0 && !globalStore.state.hasDisplayedWelcome) {
          displayWelcomeMessages(globalStore.state.welcomeMessage);
        }
      }
    }
  }, [
    globalStore.state.initialized,
    globalStore.state.welcomeMessage,
    globalStore.state.chatHistory
  ]);

  // Put the handleHello function in the actions object to pass to the MessageParser
  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleHello,
            handleReceive,
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;
